import { useState, useEffect,useRef } from "react";
import { throttle } from "lodash";

export default function useHideOnScroll() {
    const lastScrollTop = useRef(0);
    const bodyOffset = useRef(document.body.getBoundingClientRect());
    const [hidden, setHidden] = useState(false);

    const listener = throttle(e => {
        bodyOffset.current = document.body.getBoundingClientRect();
        const isDown =
            -bodyOffset.current.top > 50 && lastScrollTop.current < -bodyOffset.current.top;
        if (bodyOffset !== hidden) {
            setHidden(isDown);
        }
        lastScrollTop.current = -bodyOffset.current.top;
    }, 50);

    useEffect(() => {
        window.addEventListener("scroll", listener);
        return () => {
            window.removeEventListener("scroll", listener);
        };
    }, [listener]);

    return hidden;
}